import { createTheme } from "@mui/material/styles";

export const createAipoTheme = (mode = "dark") => {
  const dark = mode === "dark";
  const divider = dark ? "#292d36" : "#aaa5b2";
  const surface = dark ? "#14171d" : "#d9d5de";

  return createTheme({
    shape: { borderRadius: 8 },
    palette: {
      mode,
      primary: { main: dark ? "#9b72f5" : "#6d28d9", contrastText: "#ffffff" },
      background: { default: dark ? "#090a0d" : "#cfcbd4", paper: surface },
      text: { primary: dark ? "#f4f5f7" : "#211e26", secondary: dark ? "#a7acb8" : "#625d68" },
      divider,
      action: { hover: dark ? "rgba(139,92,246,0.08)" : "rgba(109,40,217,0.08)", selected: dark ? "rgba(139,92,246,0.14)" : "rgba(109,40,217,0.14)" },
      success: { main: dark ? "#55bd82" : "#2e8b57" },
      warning: { main: dark ? "#e7b05b" : "#b7791f" },
    },
    typography: {
      fontFamily: '"Segoe UI", "Inter", "Helvetica Neue", Arial, sans-serif',
      h4: { fontWeight: 700, letterSpacing: "-0.035em" },
      h5: { fontWeight: 700, letterSpacing: "-0.025em" },
      h6: { fontWeight: 700, letterSpacing: "-0.018em" },
      button: { textTransform: "none", fontWeight: 700 },
    },
    components: {
      MuiPaper: { styleOverrides: { root: { backgroundImage: "none", border: `1px solid ${divider}`, boxShadow: "none" } } },
      MuiButton: { styleOverrides: { root: { borderRadius: 8, boxShadow: "none", minHeight: 38 }, containedPrimary: { boxShadow: "none" } } },
      MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 8, backgroundColor: dark ? "#101218" : "#c6c2cc" } } },
      MuiChip: { styleOverrides: { root: { borderRadius: 7, fontWeight: 650 } } },
      MuiAppBar: { styleOverrides: { root: { backgroundImage: "none", boxShadow: "none" } } },
    },
  });
};
